import { apiRequest } from "../lib/apiClient";
import { API_BASE_URL } from "../env";
import type { ProductImageOut } from "./types";

/** `backend/app/api/v1/images.py` — product image CRUD. Upload is
 * `multipart/form-data` (fields: `file`; `is_primary` is a query param, not
 * part of the multipart body), everything else is plain JSON via `apiRequest`. */

export async function listProductImages(accessToken: string, itemId: string): Promise<ProductImageOut[]> {
  return apiRequest<ProductImageOut[]>(`/images/${itemId}`, { accessToken });
}

export async function uploadProductImage(
  accessToken: string,
  itemId: string,
  file: File,
  isPrimary: boolean,
): Promise<ProductImageOut> {
  const formData = new FormData();
  formData.append("file", file);
  const url = new URL(`${API_BASE_URL}/images/${itemId}`);
  url.searchParams.set("is_primary", String(isPrimary));
  const response = await fetch(url.toString(), {
    method: "POST",
    headers: { Authorization: `Bearer ${accessToken}` },
    body: formData,
  });
  if (!response.ok) {
    const body = (await response.json().catch(() => null)) as { detail?: string } | null;
    throw new Error(body?.detail ?? `Upload failed with status ${response.status}`);
  }
  return (await response.json()) as ProductImageOut;
}

export async function setPrimaryImage(accessToken: string, itemId: string, imageId: string): Promise<ProductImageOut> {
  return apiRequest<ProductImageOut>(`/images/${itemId}/${imageId}`, {
    method: "PATCH",
    accessToken,
    body: { is_primary: true },
  });
}

export async function deleteProductImage(accessToken: string, itemId: string, imageId: string): Promise<void> {
  await apiRequest<void>(`/images/${itemId}/${imageId}`, { method: "DELETE", accessToken });
}
